import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import classNames from 'classnames/bind';
import { hideAllLayers } from '../../../services/store/modules/app-controls';
import ControlBar from '../../shared/ControlBar/ControlBar';
import styles from './AppControls.scss';

const cx = classNames.bind(styles);

const ConnectedControlBar = ({
  showingControlBar,
  controlBarType,
  dispatchHideAllLayers,
  hidingAllLayers,
  currentMapCenter,
}) =>
  showingControlBar && (
    <ControlBar
      className={cx('app-controls__control-bar')}
      currentMapCenter={currentMapCenter}
      controlBarType={controlBarType}
      hideAllLayers={dispatchHideAllLayers}
      hidingAllLayers={hidingAllLayers}
    />
  );

ConnectedControlBar.propTypes = {
  dispatchHideAllLayers: PropTypes.func.isRequired,
  controlBarType: PropTypes.string.isRequired,
  hidingAllLayers: PropTypes.bool.isRequired,
  showingControlBar: PropTypes.bool.isRequired,
  currentMapCenter: PropTypes.shape({
    lat: PropTypes.number,
    lon: PropTypes.number,
  }),
};

ConnectedControlBar.defaultProps = {
  currentMapCenter: null,
};

const mapDispatchToProps = (dispatch) => ({
  dispatchHideAllLayers: (hide) => dispatch(hideAllLayers(hide)),
});

const mapStateToProps = (state) => ({
  showingControlBar: state.appControls.showingControlBar,
  controlBarType: state.appControls.controlBarType,
  hidingAllLayers: state.appControls.hidingAllLayers,
  currentMapCenter: state.appControls.currentMapParams.viewPortDetails.center,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ConnectedControlBar);
